import { BannerWidget } from '../../domain/models/BannerWidget';

/**
 * Application ViewModel for banner widgets.
 * Keeps application layer decoupled from domain classes.
 */
export interface BannerWidgetVm {
  name: string;
  imageUrl: string;
  desktopImageUrl: string | null;
  landingUrl: string | null;
  bannerType: string;
}

export function toBannerWidgetVm(model: BannerWidget): BannerWidgetVm {
  return {
    name: model.name,
    imageUrl: model.imageUrl,
    desktopImageUrl: model.desktopImageUrl,
    landingUrl: model.landingUrl,
    bannerType: model.bannerType,
  };
}

